export const environment = {
  production: false,
  URL_WEB: 'https://qasitio.sorteoanahuac.mx',
  URL_API_LEGALES: 'https://qaserviciossitioapp.sorteoanahuac.mx',
  URL_MICROSITIO: 'https://qapago.sorteoanahuac.mx',
  URL_API_MAGNO: 'https://qaserviciosapp.sorteoanahuac.mx',
  URL_MICROSITIO_ANIV: 'https://qapagoaniv.sorteoanahuac.mx',
  URL_API_ANIV: 'https://qaserviciosanivapp.sorteoanahuac.mx',
  ts: 'TDBHNjNuczNDdVIxVDNUQCNLM05CVFIqMjI0JTUzYzgzVA=='
};